/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal, { ModalHeader, ModalFooter } from '../../../../../components/Modal';
import Button from '../../../../../components/Button';
import Localized from '../../../../../../shared/components/Localized';

import styles from '../../../../../styles';

const ModalBody = styled.div`
  padding: 2rem;
  ${styles.fonts.base};
  color: ${styles.colors.biscay};
`;

class VerifySuccessModal extends React.Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    requests: PropTypes.object,
    onClose: PropTypes.func
  };

  render() {
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader >
          <Localized modelName={'verifyPhoneNumber'} modelKey={'verifyNumberLabel'} modelAttribute={'label'} />
        </ModalHeader>
        <ModalBody>
          <Localized modelName={'verifyPhoneNumber'} modelKey={'verifiedMessage'} modelAttribute={'label'} />
        </ModalBody>
        <ModalFooter>
          <Button theme="brand" onClick={this.props.onClose}>
            <Localized modelName={'verifyPhoneNumber'} modelKey={'closeButton'} modelAttribute={'label'} />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default VerifySuccessModal;
